import dayjs from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Icon } from 'semantic-ui-react'
import { StyledImageContainer, StyledImageWrapper } from '~/pages/Profile/style'
import { useAuth } from '~/routes/components/AuthProvider'
import { formatNumberWithoutFractions } from '~/utils/helpers'
import { StyledGridHeader, ImageWithTextWrapper } from './style'
import { MILK_MONEY_ACCOUNT_SLUG, tradingSlotModules } from '~/Constants'
import { StyledGridColumns, StyledGridRow } from '~/pages/Users/User/Show/style'
import { StyledSegment } from '../StockExchange/Show/style'

interface ShowProps {
  showData: any,
  farmerImageSrc: string
  role: string
}

const defaultImage = '/assets/images/default.png'

const Show: React.FC<ShowProps> = (props) => {
  const { showData, farmerImageSrc } = props
  const { t } = useTranslation()
  const { systemData: { amountUnit, modules } } = useAuth()

  const hasMilkMoneyModule = modules.find(module => module.slug === MILK_MONEY_ACCOUNT_SLUG)
  const hasAnyTradingModules = Boolean(modules.find(module => !!tradingSlotModules.find(tradingSlotSlug => tradingSlotSlug === module.slug)))

  function renderProfileImage() {
    return <StyledImageWrapper>
      <img src={farmerImageSrc ? farmerImageSrc : defaultImage}></img>
      <StyledImageContainer />
    </StyledImageWrapper>
  }

  function renderDefaultImage() {
    return <Icon color='blue' name='user circle' size='massive' />
  }

  function renderShowData() {
    return <StyledSegment placeholder>
      <StyledGridHeader>{t('Profile details')}</StyledGridHeader>
      <Grid style={{ padding: 20 }} columns={3} divided>
        <Grid.Row>
          <Grid.Column>
            <Grid.Row>
              <ImageWithTextWrapper>
                {farmerImageSrc ? renderProfileImage() : renderDefaultImage()}
                <div style={{ marginLeft: 15 }}>
                  <div className='company-header'>{showData?.companyName}</div>
                  <div className='role-header'>{t('Farmer')}</div>
                </div>
              </ImageWithTextWrapper>
            </Grid.Row>
          </Grid.Column>
          <Grid.Column>
            <Grid columns={2} stackable>
              <StyledGridRow>
                <Grid.Column>{t('Supplier No.')}</Grid.Column>
                <StyledGridColumns>{showData?.supplierNo}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Date of last delivery')}</Grid.Column>
                <StyledGridColumns>{showData?.lastDeliveryDate ? dayjs(showData?.lastDeliveryDate).format('DD.MM.YYYY') : '-'}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Cancellation date')}</Grid.Column>
                <StyledGridColumns>{showData?.terminationDate ? dayjs(showData?.terminationDate).format('DD.MM.YYYY') : '-'}</StyledGridColumns>
              </StyledGridRow>
              {hasAnyTradingModules && <StyledGridRow>
                <Grid.Column>{t('Total amount per year')}</Grid.Column>
                <StyledGridColumns>{showData?.amount ? `${formatNumberWithoutFractions(showData?.amount)} ${amountUnit}` : '-'}</StyledGridColumns>
              </StyledGridRow>}
              {hasMilkMoneyModule && <>
                <StyledGridRow>
                  <Grid.Column>{t('Minimum contingent')}</Grid.Column>
                  <StyledGridColumns>{showData?.minimumContingent ? `${formatNumberWithoutFractions(showData?.minimumContingent)} ${amountUnit}` : '-'}</StyledGridColumns>
                </StyledGridRow>
                <StyledGridRow>
                  <Grid.Column>{t('Trading amount per year')}</Grid.Column>
                  <StyledGridColumns>{showData?.tradingAmount ? `${formatNumberWithoutFractions(showData?.tradingAmount)} ${amountUnit}` : '-'}</StyledGridColumns>
                </StyledGridRow>
              </>
              }
            </Grid>
          </Grid.Column>
          <Grid.Column>
            <Grid columns={2} stackable>
              <StyledGridRow>
                <Grid.Column>{t('Street & house number')}</Grid.Column>
                <StyledGridColumns>{`${showData?.streetName || '-'}, ${showData?.streetNumber || '-'}`}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Postal code & City')}</Grid.Column>
                <StyledGridColumns>{`${showData?.zip || '-'}, ${showData?.city || '-'}`}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Federal state (Country)')}</Grid.Column>
                <StyledGridColumns>{`${showData?.stateName || '-'} (${showData?.countryLabel || '-'})`}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Phone number')}</Grid.Column>
                <StyledGridColumns>{showData?.phonePrefixCountryPhoneCode ? `${showData?.phonePrefixCountryPhoneCode} ${showData?.phoneNumber}` : '-'}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Telefax number')}</Grid.Column>
                <StyledGridColumns>{showData?.telefaxPrefixCountryPhoneCode ? `${showData?.telefaxPrefixCountryPhoneCode} ${showData?.telefaxNumber}` : '-'}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('District')}</Grid.Column>
                <StyledGridColumns>{showData?.localDistrict || '-'}</StyledGridColumns>
              </StyledGridRow>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </StyledSegment>
  }

  return <>
    {showData && renderShowData()}
  </>
}
export default Show